// Routing module
import { AppRoutingModule } from './app-routing.module';
// Bootstrapped app component
import { AppComponent } from './app.component';
// Angular components
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// Angular Material components
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
// Kendo commponents
import '@progress/kendo-angular-intl/locales/en-GB/all';
import { WindowModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
// All other components
import { LoginFormComponent } from './login-form/login-form.component';
import { HeaderComponent } from './header/header.component';
import { AboutComponent } from './about/about.component';
import { RetrievalRedirectComponent } from './retrieval/retrieval-redirect/retrieval-redirect.component';
import { ModalDialogStandardComponent } from './dialogs/modal-dialog-standard/modal-dialog-standard.component';
import { ModalDialogFullScreenComponent } from './dialogs/modal-dialog-full-screen/modal-dialog-full-screen.component';
import { DialogComponentDirective } from './dialogs/dialog-component.directive';
import { StandardLayoutComponent } from './layouts/standard-layout/standard-layout.component';
import { ErrorExceptionHandler } from './error-exception-handler';
import { ErrorHandlerService } from './error-handler.service';


@NgModule({
  declarations: [
    AppComponent,
    LoginFormComponent,
    HeaderComponent,
    AboutComponent,
    ModalDialogStandardComponent,
    ModalDialogFullScreenComponent,
    DialogComponentDirective,
    StandardLayoutComponent,
    RetrievalRedirectComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatMenuModule,
    MatSelectModule,
    MatSidenavModule,
    MatNativeDateModule,
    MatDatepickerModule,
    WindowModule,
    PopupModule
  ],
  providers: [
    ErrorHandlerService,
    { provide: ErrorHandler, useClass: ErrorExceptionHandler },
    Title
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
